import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Typography, Alert } from "@mui/material";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import UserPackagesQuery from "./UserPackagesQuery";
import UserPackagesList from "./UserPackagesList";
import { getUserPackagesApi } from "../../../../../services/packagesApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";


export default function UserPackages() {
  const [fetchedUserCodes, setFetchedUserCodes] = React.useState({ docs: [] });
  const [queryFetchedUserCodesData, setQueryFetchedUserCodesData] =
    React.useState({});
  const [pageAndPerPage, setPageAndPerPage] = React.useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
    totalPages: 0,
  });
  const [controlAlert, setControlAlert] = React.useState({
    open: true,
    message: "لطفا یکی از گزینه های بالا را انتخاب کنید و روی مشاهده کلیک کنید",
    severity: "warning",
    SkeletonDisplay: "none",
  });

  // کنترل شماره صفحه و تعداد در هر صفحه
  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getUserPackagesFromBack(
      "getUserPackagesApi",
      queryFetchedUserCodesData,
      PageAndPerPageValue
    );
  };

  const getUserPackagesFromBack = async (request, data, paginateData = {}) => {
    try {
      setControlAlert({
        open: true,
        message: "لطفا منتظر بمانید",
        severity: "warning",
        SkeletonDisplay: "Block",
      });
      setFetchedUserCodes({ docs: [] });
      let paginate = { ...pageAndPerPage, ...paginateData };
      if (request == "getUserPackagesApi") {
        let received = await getUserPackagesApi(data, paginate);
        const resData = checkResponseData(received);
        if (resData.success) {
          setFetchedUserCodes(resData["data"]);
          setControlAlert({
            open: true,
            message: "در خواست با موفقیت انجام شد:",
            severity: "warning",
            SkeletonDisplay: "none",
          });
          const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
            resData["data"];
          const newValues = {
            totalPages,
            hasNextPage,
            hasPrevPage,
            page,
            totalDocs,
          };
          setPageAndPerPage({
            ...pageAndPerPage,
            ...paginateData,
            ...newValues,
          });
        } else {
          setControlAlert({
            open: true,
            message: "مشکلی پیش آمده است",
            severity: "warning",
            SkeletonDisplay: "none",
          });
        }
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"]);
      console.error(error);
    }
  };

  return (
    <Grid container sx={{ textAlign: "justify", height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        <Accordion sx={{ mt: 1 }} defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>فیلتر اطلاعات</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <UserPackagesQuery
              setQueryFetchedUserCodesData={setQueryFetchedUserCodesData}
              getUserPackagesFromBack={getUserPackagesFromBack}
            />
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Collapse in={controlAlert.open}>
          <Alert
            severity={controlAlert.severity}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setControlAlert({
                    open: false,
                    message: "",
                    severity: "info",
                    SkeletonDisplay: "none",
                  });
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {controlAlert.message}
          </Alert>
        </Collapse>
        <Stack sx={{ display: controlAlert.SkeletonDisplay }} spacing={1}>
          <Skeleton />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </Stack>
        <UserPackagesList
          fetchedUserCodes={fetchedUserCodes}
          pageAndPerPage={pageAndPerPage}
          setNumberPageAndPerPage={setNumberPageAndPerPage}
        />
      </Box>
    </Grid>
  );
}
